<script>
  import Constantes from '../Classes/Constantes.js';
  export let version = Constantes.versao;
</script>

<style>
  .footer {
    background-color: #eb4f12; /* Cor laranja */
    border-top: 2px solid #3f3f3f; /* Borda superior */
    color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.3rem 1rem; /* Reduz o espaçamento */
    font-weight: bold;
    font-size: 0.9rem; /* Ajuste do tamanho da fonte */
    width: 100%; /* Largura total */
    position: fixed; /* Fixa na parte inferior da tela */
    bottom: 0; /* Alinhado ao final da tela */
    z-index: 990;
  }

  .logo {
    height: 1.2rem; /* Ajuste proporcional ao texto */
    width: auto; /* Mantém proporção da logo */
  }
</style>

<div class="footer">
  <span>{version}</span>
  <img class="logo" src="./img/andlline.png" alt="Logo">
</div>
